/** Deployed application identity (matches backend APP and CI app_name). */
export enum App {
  Ldt = 'ldt',
  SamdUs = 'samd_us',
  SamdEu = 'samd_eu',
  SamdUk = 'samd_uk',
  SamdDemo = 'samd_demo',
}
